export enum MeetingTranscriptBookmark {
  None = '',
  Saved = 'saved',
  Question = 'question'
}
